import React from 'react';
import genericField from './generic-field';

const Password = genericField('password');

export default Password;
